// TILT-SUPPORT
import options from './chart-tilt.component';

export default {
    selector: 'dtChartTilt',
    options
};